export default __webpack_public_path__ + "static/media/rewarding.3379bafd.svg";